

























































































import Vue from "vue"
import { Office } from "@/model/entity/office/office"
import { ElForm } from "element-ui/types/form"
import { countryList } from "@/model/service/country/country-service"
import _ from "lodash"

export default Vue.extend({
  data() {
    return {
      countryList: countryList,
      validationEnabled: false,
      reloadForm: 0,
      rules: {
        name: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        country: [
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        postalCode: [
          {
            max: 30,
            message: `${this.$t("user_administration.max")} 30 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        city: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        street: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        houseNumber: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 6 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        phone: [
          {
            max: 50,
            message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              if (value && !new RegExp(/^[(]?[+]?[0-9 \-\/()]+$/).test(value)) {
                callback(new Error(`${this.$t("user_administration.invalid_format.phone")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ],
        contact: [
          {
            max: 100,
            message: `${this.$t("user_administration.max")} 100 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ]
      }
    }
  },
  props: {
    office: {
      type: Object as () => Office,
      required: true
    },
    formValid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    validateForm() {
      const form = this.$refs["form"] as ElForm

      let validationResult = false
      if (!!form) {
        form.validate(valid => {
          validationResult = valid
        })
      }
      this.$emit("update:formValid", validationResult)
    },
    fuzzySearchCity(input: string, callback: any) {
      if (input && input.length >= 3) {
        this.$http
          .get("cities/fuzzy/cities?country_code=" + this.office.country.isoCodeAlpha2 + "&city=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    fuzzySearchZipcode(input: string, callback: any) {
      if (input && input.length >= 3) {
        this.$http
          .get("cities/fuzzy/zipcodes?country_code=" + this.office.country.isoCodeAlpha2 + "&zipcode=" + input)
          .then(response => {
            callback(response.data)
          })
      } else {
        callback([])
      }
    },
    setCityAndZipcode(entity: any) {
      this.office.shipmentReturn.city = entity.name
      this.office.shipmentReturn.postalCode = entity.postalCode
    }
  },
  mounted() {
    this.validateForm()
  },
  created() {
    this.office.senderId = this.office.senderId.toString()
  },
  watch: {
    office: {
      deep: true,
      handler() {
        this.validateForm()
        this.validationEnabled = !_.values(this.office.shipmentReturn).every(_.isEmpty)
        if (!this.office.shipmentReturn.country) {
          this.office.shipmentReturn.country = null
        }
        if (!this.validationEnabled) {
          this.reloadForm++
          this.$emit("update:formValid", true)
        }
      }
    }
  }
})
